import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connectToStores } from 'fluxible-addons-react';
import ContestStore from 'contest/stores/contest-store';

import ButtonGroup, { ButtonGroupItem } from '@99designs/react-components/components/ButtonGroup';
import Button from '@99designs/react-components/components/Button';
import CommentSuggestionsInfoButton from './comment-suggestions-info-button';

import { suggestionsForDesign } from 'contest/apps/design-details/rating-suggestion-text';

export class RatingSuggestions extends Component {
    render() {
        const suggestions = suggestionsForDesign(this.props.design, { stage: this.props.stage });
        const buttons = suggestions.map((text, i) => {
            return (
                <ButtonGroupItem key={i}>
                    <Button
                        key="suggestion"
                        variations={['secondary', 'fluid', 'text-suggestion']}
                        onClick={e => this.props.onSuggestionSelected(text)}
                    >
                        {text}
                    </Button>
                </ButtonGroupItem>
            );
        });

        return (
            <div style={{ marginTop: '30px' }}>
                <ButtonGroup variations={['stacked']}>
                    {buttons}
                    <ButtonGroupItem key="info">
                        <CommentSuggestionsInfoButton />
                    </ButtonGroupItem>
                </ButtonGroup>
            </div>
        );
    }
}

RatingSuggestions.propTypes = {
    design: PropTypes.shape({
        rating: PropTypes.number,
        isEliminated: PropTypes.boolean,
    }).isRequired,
    onSuggestionSelected: PropTypes.func.isRequired,
    stage: PropTypes.string.isRequired,
};

export default connectToStores(RatingSuggestions, [ContestStore], (ctx, props) => {
    return {
        stage: ctx.getStore(ContestStore).getStage(),
    };
});



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/rating-suggestions.jsx